// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back-btn span[data-v-79d9a478]{font-size:1rem;font-weight:500;color:#167ea2;margin-left:.375rem;display:none}@media(min-width:48rem){.back-btn span[data-v-79d9a478]{display:block}}.back-btn div[data-v-79d9a478]{width:1.5rem;height:1.5rem;display:flex;justify-content:center;align-items:center;border-radius:50%;background:#edf4f7;box-shadow:0 2px 4px rgba(22,126,162,.075)}.back-btn div img[data-v-79d9a478]{width:1rem;height:1rem}", ""]);
// Exports
module.exports = exports;
